import Vue from 'vue';
import '@/plugins/extend_vue_instance';

import 'cropperjs/dist/cropper.css';
import VueTouch from 'vue-touch';
import VeeValidate from 'vee-validate';
import router from './router';
import i18n from './plugins/i18n';
import App from './App.vue';
import { authTokenInterceptor } from '@/utils/jwt';
import axiosApiInstance from '@/utils/api';

axiosApiInstance.interceptors.request.use(authTokenInterceptor);

VueTouch.config.swipe = {
  direction: 'horizontal',
  threshold: 100,
};

Vue.use(VueTouch, { name: 'v-touch' });

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is_valid',
    invalid: 'is_invalid',
  },
}); // https://baianat.github.io/vee-validate/

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
